import { render, staticRenderFns } from "./ChessSquareCard.vue?vue&type=template&id=d5784876&scoped=true"
import script from "./ChessSquareCard.vue?vue&type=script&lang=js"
export * from "./ChessSquareCard.vue?vue&type=script&lang=js"
import style0 from "./ChessSquareCard.vue?vue&type=style&index=0&id=d5784876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5784876",
  null
  
)

export default component.exports